/**
 * Pixa sekmesi — dağıtıcı.
 *
 * Sayfalar src/pixa/ altında: Overview, Sales (sipariş/iade/kargo/müşteri),
 * Catalog (katalog/listingler/değişiklik geçmişi), Stock (stok),
 * System (entegrasyon/raporlar), Asistan (bulgular/sorular/kurallar).
 */
import React from 'react';
import { Loader, DisconnectedState } from './pixa/shared';
import { OverviewPage } from './pixa/Overview';
import { OrdersPage, ReturnsPage, ShipmentsPage, CustomersPage } from './pixa/Sales';
import { ProductsPage, ListingsPage, PricingPage } from './pixa/Catalog';
import { InventoryPage } from './pixa/Stock';
import { IntegrationsPage, ReportsPage } from './pixa/System';
import { AsistanPage } from './pixa/Asistan';

export default function PixaTab({ config, tab = 'overview', start, end }: {
  config: any; tab?: string; start?: string; end?: string;
}) {
  const clientId = config?.client_id;
  const host = (config?.platforms as any)?.pixa?.host || '';
  const enabled = (config?.platforms as any)?.pixa?.enabled !== false;
  if (!config?.platforms) return <Loader />;
  if (!clientId || !host || !enabled) return <DisconnectedState />;

  switch (tab) {
    case 'asistan':      return <AsistanPage clientId={clientId} />;
    case 'orders':       return <OrdersPage clientId={clientId} start={start} end={end} />;
    case 'returns':      return <ReturnsPage clientId={clientId} start={start} end={end} />;
    case 'shipments':    return <ShipmentsPage clientId={clientId} />;
    case 'customers':    return <CustomersPage clientId={clientId} />;
    case 'products':     return <ProductsPage clientId={clientId} />;
    case 'listings':     return <ListingsPage clientId={clientId} />;
    case 'pricing':      return <PricingPage clientId={clientId} start={start} end={end} />;
    case 'inventory':    return <InventoryPage clientId={clientId} />;
    case 'integrations': return <IntegrationsPage clientId={clientId} />;
    case 'reports':      return <ReportsPage clientId={clientId} start={start} end={end} />;
    default:             return <OverviewPage clientId={clientId} start={start} end={end} />;
  }
}
